<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';

	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Parallax from '$lib/Components/Parallax/Parallax.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import SocialMediaLinks from '$lib/PageSections/SocialMediaLinks/SocialMediaLinks.svelte';
	import caseStudyA from './images/LP-Customer-Reviews-Case-Study-A-02-25-20.jpg';
	import caseStudyB from './images/LP-Customer-Reviews-Case-Study-B-02-25-20.jpg';
	import caseStudyC from './images/LP-Customer-Reviews-Case-Study-C-02-25-20.jpg';
	import reviewA from './images/LP-Customer-Reviews-Top-Quote-A-03-10-20-1e8444bb-bb19-4ff0-817b-d8d2edb95f27.jpg';
	import reviewB from './images/LP-Customer-Reviews-Top-Quote-B-03-10-20.jpg';
	import reviewC from './images/LP-Customer-Reviews-Top-Quote-C-03-10-20.jpg';
	import videoA from './images/LP-Customer-Reviews-Video-A-02-25-20.jpg';
	import videoB from './images/LP-Customer-Reviews-Video-B-02-25-20.jpg';
	import videoC from './images/LP-Customer-Reviews-Video-C-02-25-20.jpg';
	import parallax from './images/customer-reviews-bottom.png';
</script>

<Section>
	<p>
		Find Indow window reviews from customers and industry experts here.
		Customers have submitted Indow inserts reviews from all over the country.
		We’ve gathered some of the most helpful reviews, so use this page as a
		jumping off point to explore.
	</p>
	<p>
		We take all customer feedback seriously. It’s what helps us continually
		innovate and spurred us to become the strong company we are today. We
		consider these Indow window reviews as an on-going conversation with
		customers that’s helping us improve each day.
	</p>
	<Bubble title="On this page you’ll find:">
		<ul>
			<li><p>Quotes from Indow reviews pages.</p></li>
			<li><p>Video reviews from customers & experts.</p></li>
			<li><p>Followup window inserts reviews years after installation.</p></li>
		</ul>
	</Bubble>
</Section>
<Section>
	<h2>Quotes from Customers</h2>
	<div
		class="
    grid grid-flow-row
    md:grid-flow-col
  "
	>
		<Image
			src={reviewA}
			alt="“I got my first Indow because a new neighbor moved in next door with several large dogs. They leave them outside and they bark and howl at all hours. Indow has changed my life! I went from being woken up several times a night to sleeping soundly. It has reduced the sound by about 70%. Now, if I hear it at all, it sounds like the dogs are down the street. I am also getting them for my home office. Thank you Indow! I couldn’t be happier.” - Kristin, Facebook"
		/>
		<Image
			src={reviewB}
			alt="“The installation of our Indows couldn’t have been smoother or simpler. Our installer Walter took the time to explain how to insert and remove the Indow, giving both my wife and I a crack at it. The entire process took under an hour (for 9 Indows) and was perfectly timed the day before Thanksgiving in 2019. Since then I’m happy to report that our monthly electric bill is already down by 20%. Highly recommend both Indows and Super Green Solutions.” - Douglas, Reviews.io"
		/>
		<Image
			src={reviewC}
			alt="“Definitely the answer to my window replacement need. The Indow Windows have definitely improved my heat retention in the winter and prevented heat from coming in in the summer. I love that I was able to maintain the historic windows in my house, and the price was much better than replacing 14 six-pane windows.” - Kelley, TrustPilot"
		/>
	</div>
</Section>
<Section>
	<h2>Indow Video Reviews</h2>
	<div
		class="
    grid grid-flow-row gap-8
    md:grid-flow-col
  "
	>
		<div>
			<p class="mb-2 font-bold">Customer Review</p>
			<a rel="external" target="_blank" href="https://youtu.be/mJzGefRurYI">
				<Image
					src={videoA}
					class="mb-4"
					alt="man holding window insert - still from indow video review by customer"
				/>
			</a>
			<p>
				This customer created an Indow review video about sound reduction in his
				bedroom. He deals with traffic noise and his neighbors run a dog daycare
				right outside his window.
			</p>
			<p>
				Watch more <a
					rel="external"
					target="_blank"
					href="https://www.youtube.com/watch?v=flVgW4H74Po&list=PLe64DtqOvhg4biKoUZuQb9k2Aysf176vG"
					>Indow reviews by customers</a
				>.
			</p>
		</div>
		<div>
			<p class="mb-2 font-bold">Customer Interview</p>
			<a rel="external" target="_blank" href="https://youtu.be/qWrQnG2_3v4">
				<Image
					src={videoB}
					class="mb-4"
					alt="hand pressing Indow window insert into place - still from Indow customer interview"
				/>
			</a>
			<p>
				We followed up with Maggie 4 years after her Indow inserts were
				installed. Watch to see how she feels years later.
			</p>
			<p>
				Watch more <a
					rel="external"
					target="_blank"
					href="https://www.youtube.com/watch?v=lUIRQdgq1HE&list=PLe64DtqOvhg4biKoUZuQb9k2Aysf176vG&index=8"
					>Indow customer stories.</a
				>
			</p>
		</div>
		<div>
			<p class="mb-2 font-bold">Window Expert Review</p>
			<a rel="external" target="_blank" href="https://youtu.be/SdB7Oj1Ayv4">
				<Image
					src={videoC}
					class="mb-4"
					alt="Scott Sidler demonstrating the use of Indow window inserts"
				/>
			</a>
			<p>
				Scott Sidler runs a restoration company and a handyman advice site The
				Craftsman Blog. He’s used Indow inserts for years and created this great
				review video.
			</p>
			<p>
				<a
					rel="external"
					target="_blank"
					href="https://www.youtube.com/watch?v=wFhy7hrIang&list=PLe64DtqOvhg4-7eEautQ5fwDSk208e6yV"
					>See more Indow in the news.</a
				>
			</p>
		</div>
	</div>
</Section>
<Section>
	<h2>Case Studies</h2>
	<p>
		We go into the homes of Indow customers to ask: what issues they were
		dealing with, how the insert installation went, and what differences the
		inserts have brought to their space.
	</p>
	<h3>Soundproofing Windows in NYC</h3>
	<Image
		src={caseStudyA}
		alt="new york apartment with large windows and soundproof window inserts"
	/>
	<p class="mb-2">
		Laurie was looking for a way to make her converted warehouse apartment more
		efficient and quiet. We followed up to see if Indow inserts were keeping out
		the bar noise.
	</p>
	<p>
		<a href="/resources/case-studies">Read more case studies about noise.</a>
	</p>
	<h3>Energy Saving in Historic Home</h3>

	<Image
		src={caseStudyB}
		alt="historic home with energy saving window inserts"
	/>
	<p class="mb-2">
		Josh & Kim updated their 1918 bungalow, but kept its character. We checked
		in to see how the renovations and energy upgrade went.
	</p>
	<p>
		<a href="/resources/case-studies"
			>Read more case studies about energy savings.</a
		>
	</p>
	<h3>Drafty Reading Nook</h3>
	<Image
		src={caseStudyC}
		alt="woman sitting next to windows with window inserts that fixed her drafty reading nook"
	/>
	<p class="mb-2">
		All Ann wanted was a comfortable place to read her books, but her
		double-pane windows let in too much cold air. We went to see her after her
		Indow inserts were installed.
	</p>
	<p>
		<a href="/resources/case-studies">Read more case studies about comfort.</a>
	</p>
</Section>
<Section>
	<h2>Indow Reviews on Social</h2>
	<p>
		See what people are saying about us on social media. Our customers are
		interactive and opinionated, join the discussion! We answer questions as
		quickly as we can there and we also have a live chat here on our website.
	</p>
	<SocialMediaLinks />
</Section>
<Awards />
<GetAFreeEstimate />
<Parallax image={parallax} />
<FeaturedArticles />
